export enum TariffCompatibility {
    ZONE_ENFORCED_DIGITAL_AND_TOMECO = 'ZONE_ENFORCED_DIGITAL_AND_TOMECO',
    ZONE_ENFORCED_DIGITAL = 'ZONE_ENFORCED_DIGITAL',
    BARRIER_GATE = 'BARRIER_GATE',
}

export function isTariffCompatibility(
    value: unknown,
): value is TariffCompatibility {
    return Object.values(TariffCompatibility).includes(
        value as TariffCompatibility,
    );
}
